module.exports = __webpack_public_path__ + "static/FuturaPTBook-99541f31c3aca8a3251b82b28ec7966e.otf";